import { PURCHASEABLES_FOR_ITEM_GET } from '@annunciate/query/dist/queries/purchase';
import { useQuery } from './base';
export const usePurchaseablesQuery = (item) => {
    const type = item.__typename;
    const id = item.id;
    return useQuery(['purchaseables'], PURCHASEABLES_FOR_ITEM_GET, { item: {
            id,
            type,
        } });
};
//# sourceMappingURL=usePurchaseablesQuery.js.map